import React from "react";
import { Link } from "gatsby";
import { Typography, Box, Chip } from "@mui/material";

function Tags({ items, label, inline, chips, headingType = "h6", sx = {} }) {
	return (
		<Box
			component={inline ? "span" : "div"}
			sx={{ ...(inline && { display: "block", lineHeight: 1 }), ...sx }}
		>
			<Typography
				variant={headingType}
				component="span"
				sx={(theme) => ({
					...(inline && {
						display: "inline-block",
						marginRight: theme.spacing(1),
						fontSize: theme.typography.caption.fontSize,
						lineHeight: 1,
					}),
				})}
			>{`${label}:`}</Typography>
			<Box
				sx={(theme) => ({
					marginBottom: inline ? 0 : theme.spacing(2),
					...(inline && { display: "inline-block" }),
				})}
				component={inline ? "span" : "div"}
			>
				{items.map((itm, i) =>
					chips ? (
						<Chip
							key={itm.slug}
							component={Link}
							to={itm.slug}
							label={itm.title}
							sx={(theme) => ({ marginRight: theme.spacing(0.5) })}
							clickable
						/>
					) : (
						<Typography
							key={itm.slug}
							component={Link}
							to={itm.slug}
							sx={(theme) => ({
								color: theme.palette.primary.main,
								textDecoration: "none",
								...(inline && {
									display: "inline-block",
									marginRight: theme.spacing(0.5),
									fontSize: theme.typography.caption.fontSize,
									lineHeight: 1,
								}),
								"&:hover, &:active, &:focus": {
									color: theme.palette.primary.dark,
									textDecoration: "underline",
								},
							})}
							variant={inline ? "caption" : "body2"}
						>
							{itm.title}
							{i === items.length - 1 ? "" : ", "}
						</Typography>
					)
				)}
			</Box>
		</Box>
	);
}

export default Tags;
